<template>
  <div class="row">
    <div class="col col-md-4">
      <div class="card">
        <div class="card-header">
          <strong>Details</strong>
        </div>
        <div class="card-body">
          <table class="table table-bordered table-striped table-condensed table-responsive">
            <tbody>
              <tr>
                <td>
                  <product-offer-icon v-bind:icon="offer.icon" width="80px"></product-offer-icon>
                </td>
                <td>
                  {{offer.codename}} <br/>
                  <span class="badge badge-info" v-if="offer.suggestion">in Suggestions area</span>
                  <span class="badge badge-default" v-else>not in Suggestions area</span>
                </td>
              </tr>
              <tr>
                <th scope="row">ID</th><td>{{offer.id}}</td>
              </tr>
              <tr>
                <th scope="row">Catalog ID</th><td>{{offer.catalog_id}}</td>
              </tr>
              <tr>
                <th scope="row">Category ID</th><td>{{offer.category_id}}</td>
              </tr>
              <tr>
                <th scope="row">Active</th>
                <td>
                  <span class="badge badge-success" v-if="offer.active">active</span>
                  <span class="badge badge-default" v-else>not active</span>
                </td>
              </tr>
              <tr>
                <th scope="row">Visibility</th>
                <td>
                  <span class="badge badge-success" v-if="offer.visibility === 'visible'">visible</span>
                  <span class="badge badge-default" v-else>not visible</span>
                </td>
              </tr>
              <tr>
                <th scope="row">Manage</th>
                <td>
                  <span class="badge badge-success" v-if="offer.manage">manage</span>
                  <span class="badge badge-default" v-else>not manage</span>
                </td>
              </tr>
              <tr>
                <th scope="row">Size</th><td>{{offer.size | prettyBytes }}</td>
              </tr>
              <tr>
                <th scope="row">Min Version</th><td>{{offer.min_version}}</td>
              </tr>
              <tr>
                <th scope="row">Max version</th><td>{{offer.max_version}}</td>
              </tr>
              <tr>
                <th scope="row">Created At</th><td>{{offer.created_at | moment('LL')}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col col-md-8">
      <div class="row">
        <div class="card">
          <div class="card-header">
            <strong>{{offer.name}}</strong>
          </div>
          <div class="card-body">
            <p v-html="offer.description"></p>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="row">
          <div class="col">
            <div class="card" v-model="offer.promotions" v-if="offer.promotions">
              <div class="card-header">
                <strong>Promotion Banner/Icon</strong>
              </div>
              <div class="text-center">
                <img class="card-img-top po-promotion-imageinside" :src="offer.promotions.banner" :alt="offer.codename">
              </div>

              <div class="po-promotion-card-body">
                <p class="card-text">
                  <router-link :to="{ name: 'Promotion', params: {id: offer.promotions.id} }">{{offer.promotions.id}}</router-link>
                  <img class="po-promotion-icon" :src="offer.promotions.icon" :alt="offer.codename" v-if="offer.promotions.icon">
                </p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card" v-model="offer.previews" v-if="offer.previews.length > 0">
              <div class="card-header">
                <strong>Previews</strong>
              </div>
              <div class="po-card-body">
                <multi-preview-item v-bind:list-previews="offer.previews" v-bind:codename="offer.codename" v-bind:icon="offer.icon"></multi-preview-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100"></div>
    <div class="col">
      <div class="card" v-if="offer.sale_options">
        <div class="card-header">
          <strong>Sale Options</strong>
        </div>
          <div class="card-body" >
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Price</th>
                  <th>InApp Product ID</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sale in offer.sale_options">
                  <td class="text-center">
                    {{sale.id}} <br/>
                    <span class="badge badge-success" v-if="sale.active">active</span>
                    <span class="badge badge-default" v-else>not active</span>
                  </td>
                  <td>
                    <sale-option v-bind:codename="sale.codename" v-bind:duration="sale.duration"/>
                  </td>
                  <td>
                    {{sale.codename}} <br/>
                    <div class="small text-muted">{{sale.inapp_product_id}}</div>
                  </td>
                  <td>
                    {{sale.created_at | moment("LL")}}
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="w-100"></div>
    <div class="col">
      <div class="card" v-if="offer.suboffers">
        <div class="card-header">
          <strong>Associated Offers</strong>
          <button v-on:click="show_products = !show_products" class="btn btn-primary po-btn">
            Collapse
          </button>
        </div>
        <div class="card-body" v-if="show_products">
          <table class="table table-bordered table-striped table-condensed">
            <thead>
              <tr>
                <th>ID</th>
                <th>Icon</th>
                <th>Name</th>
                <th>Created At</th>
                <th>Products</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="o in offer.suboffers">
                <td class="text-center">
                  {{o.suboffer.id}}
                </td>
                <td>
                  <product-offer-icon v-bind:icon="o.suboffer.icon" width="36px"></product-offer-icon>
                </td>
                <td>
                  {{o.name}}
                </td>
                <td>
                  {{o.suboffer.created_at | moment("LL")}}
                </td>
                <td>
                  <table class="po-table table-bordered table-striped table-condensed table-sm table-responsive">
                    <tr v-for="product in o.products">
                      <td class="text-center po-table-td">
                        <router-link :to="{ name: 'Product', params: {id: product.id} }">{{product.id}}</router-link>
                      </td>
                      <td class="po-table-td">
                        {{product.codename}}
                      </td>
                      <td class="po-table-td">
                        {{product.data_provider}}
                      </td>
                      <td class="po-table-td">
                        {{product.addon_type}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="w-100"></div>
    <div class="col">
      <div class="card"  v-if="offer.localized_texts">
        <div class="card-header">
          <strong>Localization</strong>
          <button v-on:click="show_translations = !show_translations" class="btn btn-primary po-btn">
            Collapse
          </button>
        </div>
          <div class="card-body" v-if="show_translations">
            <table class="table table-bordered table-striped table-condensed table-responsive">
              <tbody>
                <tr v-for="locale in getKeys">
                  <th scope="row"><img src="static/img/blank.gif" :class="'flag flag-' + locale" :alt="locale">({{locale}})</th><td>{{getNames[locale]}}</td><td v-html="getDescriptions[locale]"></td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .po-promotion-icon {
    float: left;
    width: 50px;
    z-index: 1;
    margin: -9px 0px 0px -3px; }

  .po-promotion-card-body {
    -ms-flex: 1 1 auto;
        flex: 1 1 auto;
    padding: 0.5rem; }

  .po-promotion-imageinside {
    object-fit: contain;
    width: 373px;
    padding: 0.25rem;
    transition: all 0.2s ease-in-out;}

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;}

  .fade-enter, .fade-leave-to {
    opacity: 0;}

  .po-table {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;}

  .po-table-td {
    padding: 0;
    vertical-align: top;
    border-top: 1px solid #cfd8dc; }

  .po-card-body {
    flex: 1 1 auto;
    padding: 0 1.25rem 1.25rem 1.25rem;
  }
</style>

<script>
import offers from 'services/productOffers'
import MultiPreviewItem from 'components/MultiPreviewItem'
import ProductOfferIcon from 'components/ProductOfferIcon'
import ProductOfferItem from 'components/ProductOfferItem'
import SaleOption from 'components/SaleOption'

export default {
  name: 'offer',
  created () {
    this.getOffer()
  },
  data () {
    return {
      offer: {},
      show_translations: false,
      show_products: true
    }
  },
  computed: {
    getNames () {
      return this.offer.localized_texts.filter(text => text['localizable_attribute'] === 'names')[0].data
    },
    getDescriptions () {
      return this.offer.localized_texts.filter(text => text['localizable_attribute'] === 'descriptions')[0].data
    },
    getKeys () {
      return Object.keys(this.offer.localized_texts.filter(text => text['localizable_attribute'] === 'descriptions')[0].data)
    }
  },
  components: {
    ProductOfferItem,
    MultiPreviewItem,
    ProductOfferIcon,
    SaleOption
  },
  methods: {
    getOffer () {
      offers.get(this, this.$route.params.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/offers/Offer.vue